// extracted by mini-css-extract-plugin
export default {"_":"AboutMe____+QX3E","prePseudo":"AboutMe_prePseudo__kskuD","content":"AboutMe_content__dC7D0","list":"AboutMe_list__DhEZE"};